export const daysToDisplayed = {
  today: {
    id: 0,
    label: 'Bugün',
    startDate: new Date().setHours(0, 0, 0, 0),
    endDate: new Date().getTime(),
  },
  lastWeek: {
    id: 1,
    label: 'Son 1 Hafta',
    startDate: new Date().setTime(
      new Date().getTime() - 7 * 24 * 60 * 60 * 1000,
    ),
    endDate: new Date().getTime(),
  },
  lastMonth: {
    id: 2,
    label: 'Son 1 Ay',
    startDate: new Date().setTime(
      new Date().getTime() - 30 * 24 * 60 * 60 * 1000,
    ),
    endDate: new Date().getTime(),
  },
  customSelect: {
    id: -1,
    label: 'Özel Tarih',
  },
};

export default daysToDisplayed;
